import {Component, Input, OnInit} from '@angular/core';
import {PortalService} from '../../../vna_portal/model/PortalService';

@Component({
  selector: 'app-external-callback-nav',
  templateUrl: './external-callback-nav.component.html',
  styleUrls: ['./external-callback-nav.component.scss']
})
export class ExternalCallbackNavComponent implements OnInit {

    @Input() portalService: PortalService;
    contentTitle: string = '';
    currentType: string;

    constructor() {

    }

    ngOnInit() {
        this.showComponent('list', 'External callback list');
    }

    showComponent(type: string, title : string){
        this.currentType = type;
        this.contentTitle = title;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/external-callback-nav/external-callback-nav.component.ts